import React, {Component} from 'react'
import { connect } from 'react-redux'

import ChatLog from '../ChatLog/index'
import StreamingControlButton from '../StreamingControlButton/index'
import RoomSendButton from '../RoomSendButton/index'
import Registry from '../../../registry/index';

import Panel from '../UIKit/Panel/index'
import TextInput from '../UIKit/TextInput/index'

import JoinLeaveButton from '../JoinLeaveButtons/index'

import {
    ROOM_STAYED
} from '../../../constants/rooms';

import './styles.scss';

class ChatroomJoin extends Component {


}

class Chatroom extends Component {
    stayInRoom() {
        let {room} = this.props;

        this.props.dispatch({type: ROOM_STAYED, roomid: room.roomid});
    }

    leaveRoom() {
        let {room} = this.props;

        if (!room.active) {
            return false;
        }

        let chatInterface = Registry.get('chatInterface');

        chatInterface.leaveRoom(
            room.roomid,
            function() {},
            function() {})
    }

    sendMessageToRoom() {
        let chatInterface = Registry.get('chatInterface');
        //{browser} = this.props;

        let messageText = this.editorInstance.value();

        let message = {
            message: messageText,
            roomid: this.props.room.roomid
        };

        chatInterface.sendRoomMessage(message, this._onRoomMessageSendSuccess, this._onRoomMessageSendError);
        this.editorInstance.clearEditor();

         //if (browser.phone) editorInstance.blur();
    }

    renderRoomJoin() {
        let room = this.props.room;
        if (!room) return null;
        //let roomid = room.roomid;
        //let chatInterface = Registry.get('chatInterface');
        //let mainRoomId = chatInterface.getDefaultRoomId();
        // if (roomid == mainRoomId) return null;

        if (!this.props.browser.mobile) {
            return (<Panel>
                <JoinLeaveButton style="round" roomInfo={this.props.currentRoomInfo} roomStayed={this.props.currentRoomStayed} roomActive={this.props.currentRoomActive} />
            </Panel>)
        } else {
            return null;
        }
    }

    registerEditor(r) {
        if (!r) return;
        this.editorInstance = r; 
        let roomEditorInstanceName = 'roomEditorInstance__' + this.props.room.roomid;
        
        if (Registry.exists(roomEditorInstanceName)) {
            Registry.remove(roomEditorInstanceName);
        }

        Registry.add('roomEditorInstance__' + this.props.room.roomid, r);
    }

    render() {
        let { currentUser, newMessageBtnHandler, visible, chatLogMargin } = this.props;
        let room = this.props.room;
        if (!room) return null;
        let roomid = room.roomid;
        let classNames = ["block-chat"];
        if (visible) {
            classNames.push("visible");
        }
        if (chatLogMargin) {
            classNames.push("margin");
        }
        let disabled = !currentUser || currentUser.isAnonymous() || !currentUser.isCertified();

        return (
            <div className={classNames.join(" ")}>
                {this.renderRoomJoin()}
                <ChatLog roomid={roomid} newMessageBtnHandler={newMessageBtnHandler} visible={visible}/>

                <div className="bot-chat">
                    <div className="block-bot-chat-content">
                        <div className="block-bot-chat">
                            <div className="left-block-bot-chat">
                            <StreamingControlButton/>
                            </div>
                            
                            <div className='center-block-bot-chat'>
                                <TextInput currentUser={this.props.currentUser} smiles={true} textStyle={true} editorStyle={this.props.editorStyle} attachments={true}
                                onSubmit={this.sendMessageToRoom.bind(this)} ref={(r) => {this.registerEditor(r); }}/>
                            </div>

                            <div className="right-block-bot-chat">
                                <RoomSendButton disabled={disabled} onClick={this.sendMessageToRoom.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let room = state.rooms[state.visibleChatrooms.roomid];

    return {
        currentRoomInfo: room ? room.info : undefined,
        currentRoomStayed: room ? room.stayed : false,
        currentRoomActive: room ? room.active : false,

        browser: state.browser,
        currentUser: state.currentUser,
        editorStyle: state.editorStyle,
        // todo: change to currentRoomUserCount prop to prevent frequent DOM updates
        users: state.users
    }
}

export default connect(mapStateToProps)(Chatroom);




// WEBPACK FOOTER //
// ./src/components/bobtv-neo/Chatroom/index.js